import axios from 'axios';
import React, { useState } from 'react';
import authService from '../../../../Components/Login/auth.service';
import '../../../../styles/pages/SubMenuPages/SubMenuTipoDeObservacao/modal-tiposDeobservacoes/modalNovoTipoDeobservacao.css';

export default function Modal({ setOpenModal, modalInfo }) {
  var user = authService.getCurrentUser();
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdObservacaoTipo: modalInfo.IdObservacaoTipo,
    IdEmpresa: modalInfo.IdEmpresa,
    otpDescricao: modalInfo.otpDescricao,
    otpFatorPositivo: modalInfo.otpFatorPositivo,
    otpFatorNegativo: modalInfo.otpFatorNegativo,
    otpFatorNeutro: modalInfo.otpFatorNeutro,
    otpPermitirNA: parseInt(modalInfo.otpPermitirNA),
    otpStatus: parseInt(modalInfo.otpStatus),
    otpObservacoes: modalInfo.otpObservacoes,
    otpAlteradoPor: user[0].pesEmail,
    otpAlteradoEm: newDate
  })
  //console.log(campos)
  function handleInputChange(event) {
    if (event.target.name === 'otpPermitirNA') {
      //console.log(event.target.checked)
      if (event.target.checked === true) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else if (event.target.name === 'otpStatus') {
      if (event.target.checked === true) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)

    //console.log(campos)
  }

  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .post(
        process.env.REACT_APP_API_URL +
        '/api/v1/observacaotipo/' +
        modalInfo.IdObservacaoTipo,
        campos
      )
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }
  return (
    <>

      <div
        onClick={() => {
          setOpenModal(false)
        }}
        className="overlay"
      ></div>
      <div className="overlay">
        <div className="modalPadrao-content">
          <div className="cxTituloPadrao">
            <h1>
              Editar Dados Checklist
              <hr className="hrTitleModal" />
            </h1>
            <button className="close-modal" onClick={() => { setOpenModal(false) }}>
              X
            </button>
          </div>

          <form onSubmit={handleFormSubmit}>
            <label>
              Descrição:
            </label>
            <input
              type="text"
              id="otpDescricao"
              defaultValue={campos.otpDescricao}
              name="otpDescricao"
              onChange={handleInputChange}
            ></input>
            <label className="NTOFatores">
              Fatores para cálculo de resultado final da observação:
            </label>
            <label>
              FÓRMULA: (Total Positivo + Total Negativo + Total Neutro) - Total Negativo.
            </label>
            <div className="linhaTipObs">

              <tr>
                <th>
                  <label>Positivo:</label>
                </th>
                <th>
                  <label>Negativo:</label>
                </th>
                <th>
                  <label>Neutro:</label>
                </th>
              </tr>
              <tr>
                <td>
                  <label>
                    <input
                      // className="NTOPositivo"
                      placeholder="Nº"
                      type="number"
                      id="otpFatorPositivo"
                      name="otpFatorPositivo"
                      defaultValue={campos.otpFatorPositivo}
                      onChange={handleInputChange}
                    ></input>
                  </label>
                </td>
                <td>
                  <input
                    // className="NTONegativo"
                    placeholder="Nº"
                    type="number"
                    id="otpFatorNegativo"
                    name="otpFatorNegativo"
                    defaultValue={campos.otpFatorNegativo}
                    onChange={handleInputChange}
                  ></input>
                </td>
                <td>
                  <input
                    // className="NTONeutro"
                    placeholder="Nº"
                    type="number"
                    id="otpFatorNeutro"
                    name="otpFatorNeutro"
                    defaultValue={campos.otpFatorNeutro}
                    onChange={handleInputChange}
                  ></input>
                </td>
              </tr>
            </div>

            <label>
              Observação:
            </label>
            <textarea
              type="text"
              id="otpObservacoes"
              name="otpObservacoes"
              row="none"
              defaultValue={campos.otpObservacoes}
              maxLength="500"
              onChange={handleInputChange}
            ></textarea>

            <div className="caixaSalvarPadrao">
              <div className="InputAuthorization1" >
                <label>
                  <input
                    name="otpPermitirNA"
                    type="checkbox"
                    onChange={handleInputChange}
                    defaultChecked={!!campos.otpPermitirNA} />
                  <span style={{ width: 300, position: 'relative' }}>
                    Permitir resposta NÃO APLICADO no APP
                  </span>
                </label>
              </div>
            </div>

            <div className="caixaSalvarPadrao">
              <div className="InputAuthorization1">
                <label>
                  <input
                    name="otpStatus"
                    type="checkbox"
                    onChange={handleInputChange}
                    defaultChecked={!!campos.otpStatus} />
                  <span style={{ width: 300, left: -25, position: 'relative' }}>
                    Permitir uso do Checklist no APP
                  </span>
                </label>
              </div>
              <button type="submit" className="gravar-modal">
                Salvar Checklist
              </button>
            </div>
          </form>

        </div>
      </div>
    </>
  )

}
